import { useState } from 'react';
import { API_URL, API_VERSION } from '@constants';
import { paths } from '../../types/api';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/logs/user-events';
const ENDPOINT_URL_WITH_VERSION = `${API_VERSION}${ENDPOINT_URL}` as const;
type url = typeof ENDPOINT_URL_WITH_VERSION;

export type LogEvent = paths[url]['post'];

export interface CreateLogSuccessResponse {
    message: string;
}

export interface LogEventProps {
    to_uuid: string;
    event_type_name: string;
    action: string,
    to?: string
}
/**
 * Requests endpoint to register a new user account.
 */
export const useLogUserCall = () => {
     const { getHeaders, getCommonParameters, handleCommonErrors } = useApiConfig();
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [lastResponseTime, setLastResponseTime] = useState<Date | null>(null);
    const [success, setSuccess] = useState<string | null>(null);

    const request = async (props: LogEventProps) => {
        setLoading(true);
        setError(null);

        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL}`, {
                method: 'POST',
                headers: getHeaders(),
                  body: JSON.stringify({ ...getCommonParameters(), ...props }),
            });

            const data: CreateLogSuccessResponse = await response.json();

            if (!response.ok) {
                const errorMessage = data.message || 'An error occurred';
                const error = new Error(errorMessage) as ApiError;
                error.statusCode = response.status;
                throw error;
            }

            setSuccess(data.message);
            return data.message;

            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err: any) {
            handleCommonErrors(err);
            err.message && setError(err.message);
        } finally {
            setLoading(false);
            setLastResponseTime(new Date());
        }
    };

    return { request, loading, error, lastResponseTime, success };
};
